/* BBRU homepage quick-add — single, guarded /cart/add.js (never doubles), then
   best-effort refresh of the theme's cart UI. 2026-07-03. */
(function () {
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // update any common cart-count elements
        var sels = ['[data-cart-count]', '.cart-count', '.cart-badge span', '[data-cart-item-count]', '.js-cart-count'];
        sels.forEach(function (s) {
          document.querySelectorAll(s).forEach(function (el) { el.textContent = cart.item_count; });
        });
        // notify theme scripts that may drive a drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bh-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var orig = btn.textContent;
    btn.textContent = 'adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.textContent = 'added ✓';
        refreshCart();
        if (typeof window.bhOpenCart === 'function') { window.bhOpenCart(); }
        setTimeout(function () { btn.textContent = orig; btn.removeAttribute('aria-busy'); }, 1800);
      })
      .catch(function () { btn.textContent = orig; btn.removeAttribute('aria-busy'); });
  });
})();
